export enum ClaimType {
    LOST = 'loss_Ext',
    MISSING_CONTENTS = 'fallout_Ext',
    DAMAGED = 'damage_Ext',
}
